import { Box, Button } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import { FC, useCallback, useEffect, useState } from "react";
import {
  Abordagem,
  Localizacao,
  PsicologoEF,
  createPsicologoEF,
  deletePsicologoEF,
  getAbordagens,
  getLocalizacoes,
  getPsicologosEF,
  updatePsicologoEF,
  uploadPsicologoPhoto,
} from "src/apis/eezyfamily";
import PageContainer from "src/pages/components/PageContainer";
import { isUserAdministrator } from "src/utils/auth";
import PsicologosTable from "./components/PsicologosTable";
import PsicologoModal from "./components/PsicologoModal";

const EFPsicologosPage: FC = (): JSX.Element => {
  const [entries, setEntries] = useState<PsicologoEF[]>([]);
  const [localizacoes, setLocalizacoes] = useState<Localizacao[]>([]);
  const [abordagens, setAbordagens] = useState<Abordagem[]>([]);
  const [error, setError] = useState("");
  const [modalOpen, setModalOpen] = useState(false);
  const [editTarget, setEditTarget] = useState<PsicologoEF | null>(null);

  const load = useCallback(async () => {
    try {
      const [psics, locs, abords] = await Promise.all([
        getPsicologosEF(),
        getLocalizacoes(),
        getAbordagens(),
      ]);
      setEntries(psics);
      setLocalizacoes(locs);
      setAbordagens(abords);
      setError("");
    } catch (err: any) {
      setError(err?.message ?? "Erro ao carregar dados.");
    }
  }, []);

  useEffect(() => {
    load();
  }, [load]);

  const handleEdit = (item: PsicologoEF) => {
    setEditTarget(item);
    setModalOpen(true);
  };

  const handleAdd = () => {
    setEditTarget(null);
    setModalOpen(true);
  };

  const handleDelete = async (id: number) => {
    if (
      !window.confirm(
        "Tem certeza que deseja excluir este psicólogo? Esta ação não pode ser desfeita."
      )
    )
      return;
    try {
      await deletePsicologoEF(id);
      setEntries((prev) => prev.filter((e) => e.id !== id));
    } catch (err: any) {
      setError(err?.message ?? "Erro ao excluir.");
    }
  };

  const handleSaved = () => {
    setModalOpen(false);
    load();
  };

  return (
    <PageContainer title="Psicólogos EezyFamily" error={error} guard={isUserAdministrator}>
      <Box sx={{ display: "flex", justifyContent: "flex-end", mb: 1 }}>
        <Button
          variant="contained"
          startIcon={<AddIcon />}
          onClick={handleAdd}
        >
          Adicionar Psicólogo
        </Button>
      </Box>

      <PsicologosTable
        psicologos={entries}
        onEdit={handleEdit}
        onDelete={handleDelete}
      />

      <PsicologoModal
        open={modalOpen}
        editTarget={editTarget}
        localizacoes={localizacoes}
        abordagens={abordagens}
        onClose={() => setModalOpen(false)}
        onSaved={handleSaved}
        onCreate={createPsicologoEF}
        onUpdate={updatePsicologoEF}
        onUploadPhoto={uploadPsicologoPhoto}
      />
    </PageContainer>
  );
};

export default EFPsicologosPage;
